import Vue from 'vue';
import { formatSeconds, calculateDuration, formatSize, formatTraffficSize } from './utils';

/**
 * 默认值
 */
Vue.filter('defalutValue', value => {
  return value || '--';
});

/**
 * 时间格式化
 */
Vue.filter('formatDate', (time, fmt = 'yyyy-MM-dd HH:mm:ss', timezone = false) => {
  if (!time) return '';
  let dt;

  // 如果时区参数为true，转换成当前时区
  if (timezone) {
    const date = new Date(time);

    // 使用 toLocaleString 来将时间转为当前时区
    dt = new Date(
      date.toLocaleString('en-US', {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      })
    );
  } else {
    if (/-/g.test(`${time}`)) {
      time = `${time}`.replace(/-/g, '/');
    }
    dt = new Date(/\//g.test(time) ? time : Number(time));
  }

  if (String(dt) === 'Invalid Date') return time;

  const o = {
    'M+': dt.getMonth() < 9 ? dt.getMonth() + 1 : dt.getMonth() + 1, // 月份
    'd+': dt.getDate() < 10 ? dt.getDate() : dt.getDate(), // 日
    'h+': dt.getHours() % 12 === 0 ? 12 : dt.getHours() % 12, // 小时
    'H+': dt.getHours() < 10 ? dt.getHours() : dt.getHours(), // 小时
    'm+': dt.getMinutes() < 10 ? dt.getMinutes() : dt.getMinutes(), // 分
    's+': dt.getSeconds() < 10 ? dt.getSeconds() : dt.getSeconds(), // 秒
    'q+': Math.floor((dt.getMonth() + 3) / 3), // 季度
    S: dt.getMilliseconds() < 10 ? dt.getMilliseconds() : dt.getMilliseconds(), // 毫秒
  };
  const week = {
    '0': '/u65e5',
    '1': '/u4e00',
    '2': '/u4e8c',
    '3': '/u4e09',
    '4': '/u56db',
    '5': '/u4e94',
    '6': '/u516d',
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, `${dt.getFullYear()}`.substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (RegExp.$1.length > 1 ? (RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468') : '') +
        week[`${dt.getDay()}`]
    );
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
      );
    }
  }
  return fmt;
});

/**
 * 千分位格式化数字
 *
 * @export
 * @param {any} num
 * @param {Boolean} decimal 是否保留2位小数
 * @returns {String}
 */

Vue.filter('formatK', (num, decimal = true) => {
  if (num === null || Number.isNaN(Number(num))) {
    return '0';
  }
  let tmp = parseFloat(num).toFixed(decimal ? 3 : 0); // 格式化为两位小数
  if (decimal) {
    tmp = tmp.substring(0, tmp.toString().length - 1);
  }
  const [intPart, decPart] = tmp.split('.'); // 拆分整数和小数部分

  const tempArr = [];
  const revArr = intPart.split('').reverse(); // 倒序

  revArr.forEach((n, i) => {
    tempArr.push(n);
    if ((i + 1) % 3 === 0 && +i !== revArr.length - 1) tempArr.push(',');
  });

  const formatedIntPart = tempArr.reverse().join(''); // 整数部分
  let result = decPart ? [formatedIntPart, decPart].join('.') : formatedIntPart;
  result = result === 'NaN' ? '--' : result;
  return result;
});

/**
 * num: 传入数值，建议为数字
 * decimal: 需要保留的小数位，默认不处理
 * @return 字符串值
 */
Vue.filter('thousandsSeparator', (num, decimal = null, defautText = '--') => {
  let isDecimal = false;
  // decimal必须为正整数
  if (typeof decimal === 'number' && /^[+]{0,1}(\d+)$/gi.test(decimal)) {
    isDecimal = true;
  }

  // 如果已经包含逗号
  if (/,/gi.test(num)) {
    return num;
  }

  // 值为0,-0，则直接返回
  if ([0, -0, '0', '-0'].includes(num)) {
    // 0也保留小数
    if (isDecimal) {
      return Number(num).toFixed(decimal);
    }
    return num;
  }

  // 如果不能转数字，或为''或为false，则显示三点
  if (
    Number.isNaN(Number(num)) ||
    !num ||
    (typeof num === 'string' && !num.replace(/^\s+|\s+$/g, ''))
  ) {
    return defautText;
  }

  // 转成字符串
  let strNum = String(num);
  if (isDecimal) {
    strNum = Number(num).toFixed(decimal);
  }

  // 拆成两部分
  const initStrNum = strNum.split('.')[0];
  const decimalStrNum = strNum.split('.')[1];

  // 对整数位进行千分位分隔
  const resultInitStrNum = initStrNum.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');

  // 返回字符串值，只用于显示
  return resultInitStrNum + (decimalStrNum ? '.' + decimalStrNum : '');
});

/**
 * 获取地址栏参数
 *
 * @export
 * @returns {Object}
 */
Vue.filter('queryString', () => {
  const params = {};
  const search = window.location.search.substring(1);

  if (!search) return {};

  search.split('&').forEach(str => {
    const piece = str.split('=');

    if (piece[1]) params[piece[0]] = decodeURIComponent(piece[1]);
  });

  return params;
});

/**
 * debounce  函数去抖
 *
 * @export
 * @param {Function} func
 * @param {Number} wait
 * @returns {Function}
 */
Vue.filter('debounce', function(func, wait) {
  const args = arguments;

  window.clearTimeout(func.debounce);
  func.debounce = setTimeout(() => {
    func(...args);
  }, wait);
});

Vue.filter('type', o =>
  Object.prototype.toString
    .call(o)
    .split(' ')[1]
    .slice(0, -1)
    .toLowerCase()
);

/**
 * isEmpty
 *
 * @export
 * @param {*} r
 * @returns
 */
Vue.filter('isEmpty', r => {
  if (!r) return true;
  if (Array.isArray(r)) return !r.length;
  if (typeof r === 'object') {
    for (const key in r) return false;
    return true;
  }
  return false;
});

/**
 * 格式化金额为万元
 */
Vue.filter('tenthousand', amount => {
  amount *= 1;
  if (!amount || amount < 10000) {
    return `${amount}元`;
  }
  amount = (amount / 10000).toFixed(2);
  return `${amount * 1}万`;
});

/**
 * 小数转百分比
 */
Vue.filter('percent', val => `${parseFloat((val * 100).toPrecision(12))}%`);

/**
 * 去掉两边的空格
 */
Vue.filter('trim', val => val.replace(/(^\s*)|(\s*$)/g, ''));

/**
 * 格式化手机号显示 3 4 4格式
 */
Vue.filter('formatMobile', val => {
  if (val) {
    return String(val).replace(/(^\d{3}|\d{4}\B)/g, '$1 ');
  }
  return '';
});

/**
 * 统计过滤
 */
Vue.filter('stat', val => {
  if (val || val === 0) {
    return val;
  }
  return '--';
});

Vue.prototype.filter = Vue.filter;

// 过滤地址中的0
Vue.filter('location', val => {
  if (val) {
    return String(val).replace(/\|0/g, '');
  }
  return window.$t('com_location_default');
});

// 格式化秒数
Vue.filter('formatSeconds', val => {
  if (val) {
    return formatSeconds(val);
  }
  return '';
});

// 计算时长
Vue.filter('calculateDuration', val => {
  if (val) {
    return calculateDuration(val);
  }
  return '';
});

/**
 * 格式化文件大小
 * @param {number} size - 文件大小，单位为字节
 * @returns {string} - 带单位的文件大小字符串 保留两位小数
 */
Vue.filter('formatSize', size => {
  return formatSize(size);
});

// 格式化流量大小
Vue.filter('formatTraffficSize', size => {
  return formatTraffficSize(size);
});
